/* tslint:disable */
import {
  App,
  Entity,
  Entityrecord,
  Account
} from '../index';

declare var Object: any;
export interface ActivityInterface {
  CallDurationInSeconds?: number;
  CallObject?: string;
  CallDisposition?: string;
  CallType?: string;
  comments?: string;
  IsRecurrence?: boolean;
  activityDate?: Date;
  Email?: string;
  WhoId?: string;
  Phone?: string;
  priority?: string;
  RecurrenceInterval?: string;
  RecurrenceRegeneratedType?: string;
  status?: string;
  subject?: string;
  subtype?: string;
  type?: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  appId?: any;
  entityId?: any;
  entityrecordId?: any;
  accountId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
  entity?: Entity;
  entityrecord?: Entityrecord;
  account?: Account;
}

export class Activity implements ActivityInterface {
  CallDurationInSeconds: number;
  CallObject: string;
  CallDisposition: string;
  CallType: string;
  comments: string;
  IsRecurrence: boolean;
  activityDate: Date;
  Email: string;
  WhoId: string;
  Phone: string;
  priority: string;
  RecurrenceInterval: string;
  RecurrenceRegeneratedType: string;
  status: string;
  subject: string;
  subtype: string;
  type: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  appId: any;
  entityId: any;
  entityrecordId: any;
  accountId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  entity: Entity;
  entityrecord: Entityrecord;
  account: Account;
  constructor(data?: ActivityInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Activity`.
   */
  public static getModelName() {
    return "Activity";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Activity for dynamic purposes.
  **/
  public static factory(data: ActivityInterface): Activity{
    return new Activity(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Activity',
      plural: 'activities',
      properties: {
        CallDurationInSeconds: {
          name: 'CallDurationInSeconds',
          type: 'number'
        },
        CallObject: {
          name: 'CallObject',
          type: 'string'
        },
        CallDisposition: {
          name: 'CallDisposition',
          type: 'string'
        },
        CallType: {
          name: 'CallType',
          type: 'string'
        },
        comments: {
          name: 'comments',
          type: 'string'
        },
        IsRecurrence: {
          name: 'IsRecurrence',
          type: 'boolean'
        },
        activityDate: {
          name: 'activityDate',
          type: 'Date'
        },
        Email: {
          name: 'Email',
          type: 'string'
        },
        WhoId: {
          name: 'WhoId',
          type: 'string'
        },
        Phone: {
          name: 'Phone',
          type: 'string'
        },
        priority: {
          name: 'priority',
          type: 'string'
        },
        RecurrenceInterval: {
          name: 'RecurrenceInterval',
          type: 'string'
        },
        RecurrenceRegeneratedType: {
          name: 'RecurrenceRegeneratedType',
          type: 'string'
        },
        status: {
          name: 'status',
          type: 'string'
        },
        subject: {
          name: 'subject',
          type: 'string'
        },
        subtype: {
          name: 'subtype',
          type: 'string'
        },
        type: {
          name: 'type',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        entityId: {
          name: 'entityId',
          type: 'any'
        },
        entityrecordId: {
          name: 'entityrecordId',
          type: 'any'
        },
        accountId: {
          name: 'accountId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
        entity: {
          name: 'entity',
          type: 'Entity',
          model: 'Entity'
        },
        entityrecord: {
          name: 'entityrecord',
          type: 'Entityrecord',
          model: 'Entityrecord'
        },
        account: {
          name: 'account',
          type: 'Account',
          model: 'Account'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Activity.ts